export default class SystemError extends Error {
  constructor(code, message) {
    super(message);

    this.code = code;
    this.name = 'SystemError';
  }
}
